import React, { memo } from 'react'

import { bool } from 'prop-types'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { parseGeneratingRunId } from 'Pods/ThreeDStudio/Hooks/generatingRunUrl'
import { parseRunSlugFromPathname } from 'Pods/ThreeDStudio/Hooks/parseRunSlugFromPathname'
import useIsWatchingGeneratingRun from 'Pods/ThreeDStudio/Hooks/useIsWatchingGeneratingRun'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import LoadingBanner from '../LoadingBanner/LoadingBanner'
import GenerationProgress from './Components/GenerationProgress/GenerationProgress'
import RelatedProducts from './Components/RelatedProducts/RelatedProducts'

// Picks the loading variant from the URL: a model-detail URL means we're
// hydrating that run ("Loading 3D model"); anything else means the user is
// watching their own generation, shown as the phase-driven progress card. The
// watched run takes precedence so users who started a generation keep the
// progress card even though the post-completion history.replace will move them
// onto a model-detail URL.
function LoadingBannerState({ forceSharedRun = false }) {
  const t = useTranslation()
  const location = useLocation()
  const isWatchingGeneratingRun = useIsWatchingGeneratingRun()
  const urlHasModelSlug = parseRunSlugFromPathname(location?.pathname ?? '') != null
  const isSharedRunView = forceSharedRun || (urlHasModelSlug && !isWatchingGeneratingRun)
  const watchedRunId = parseGeneratingRunId(location?.search ?? '')
  const watchedRun = useThreeDStudioStore((state) => {
    const { activeRuns } = state.generation
    return activeRuns.find(run => String(run.runId) === String(watchedRunId))
      ?? activeRuns[activeRuns.length - 1]
  })

  if (isSharedRunView) {
    return <LoadingBanner title={t('viewer.banner.loadingTitle')} />
  }

  return (
    <LoadingBanner withSpinner={false}>
      <GenerationProgress run={watchedRun} />
      <RelatedProducts />
    </LoadingBanner>
  )
}

LoadingBannerState.propTypes = {
  forceSharedRun: bool,
}

export default memo(LoadingBannerState)
